import essApi from "../axios/essApi";
import jsPDF from 'jspdf';

async function convertImageToPDF(imageFile) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = URL.createObjectURL(imageFile);

    img.onload = () => {
      const pdf = new jsPDF();
      const imgWidth = pdf.internal.pageSize.getWidth();
      const imgHeight = (img.height * imgWidth) / img.width;

      pdf.addImage(img, 'JPEG', 0, 0, imgWidth, imgHeight);
      resolve(pdf.output('blob'));
    };

    img.onerror = (error) => {
      console.error('Error loading image:', error);
      reject(error);
    };
  });
}

class TrainingService {
  async getEngagementTypes() {
    return Promise.resolve(essApi.get(`engagement`));
  }
  async getTrfHistory() {
    return Promise.resolve(essApi.get(`trainingForms`));
  }
  async getTrfValidationHistory() {
    return Promise.resolve(essApi.get(`training_team`));
  }
  async getManagerTrfHistory() {
    return Promise.resolve(essApi.get(`trainingForm`));
  }
  async fetchTrainingCategoryList() {
    return Promise.resolve(essApi.get(`training`));
  }
  async getRatings() {
    return Promise.resolve(essApi.get(`rating`));
  }
  async createTraining(param) {
    return Promise.resolve(essApi.post(`training_Deatils`, param));
  }
  async updateTraining(param) {
    return Promise.resolve(essApi.put(`training_Deatils/${param.id}`, param));
  }
  async fetchTrainings() {
    return Promise.resolve(essApi.get(`training_Deatils`));
  }
  async fetchTeamTrainings() {
    return Promise.resolve(essApi.get(`training_DeatilsbySupior`));
  }
  async fetchonJobTrainings() {
    return Promise.resolve(essApi.get(`training_onjob`));
  }
  async fetchTrainingsByUserID(id) {
    return Promise.resolve(essApi.get(`training_Deatils_user/${id}`));
  }
  async fetchTrfHistoryByUserID(id) {
    return Promise.resolve(essApi.get(`trf_userid/${id}`));
  }
  async fetchTrainingByID(id) {
    return Promise.resolve(essApi.get(`training_Deatils/${id}`));
  }
  async deleteTraining(id) {
    return Promise.resolve(essApi.delete(`training_Deatils/${id}`));
  }
  async fetchSkillsByID(id) {
    return Promise.resolve(essApi.get(`user-Skill-by-user-id/${id}`));
  }
  async updateEmployeeTraining(param) {
    return Promise.resolve(essApi.put(`training_Deatils`, param));
  }
  async createTRFform(param) {
    return Promise.resolve(essApi.post(`trainingForm`, param));
  }

  async createMultiTRFform(param) {
    return Promise.resolve(essApi.post(`trainingForm_bulkcreate`, param));
  }

  async updateTRFform(param) {
    return Promise.resolve(essApi.put(`trainingForm`, param));
  }
  async fetchTrainingFormByID(id) {
    return Promise.resolve(essApi.get(`trainingForm/${id}`));
  }
  async updateApproveRejectTrainingForm(param) {
    return Promise.resolve(essApi.put(`training_Form`, param));
  }
  async updateApproveRejectMultiTrainingForm(param) {
    return Promise.resolve(essApi.put(`training_Form_bulk`, param));
  }
  async deleteTrainingFormByID(id) {
    return Promise.resolve(essApi.delete(`trainingForm/${id}`));
  }
  async getRequestedTraining() {
    return Promise.resolve(essApi.get(`requested-traning`));
  }
  async fetchTrainingApprovals() {
    return Promise.resolve(essApi.get('team-trf-approval'));
  }
  async filterTrfBySkill(param) {
    return Promise.resolve(essApi.get(`filter_by_title?search=${param.skill}&category=${param.category}`));
  }


  async getTMTaskList(userId) {
    return Promise.resolve(essApi.get(`trainingTaskList/${userId}`));
  }

  async getAsignedTrainingListCount() {
    return Promise.resolve(essApi.get(`trainingTaskListcount`));
  }

  // async uploadTrainingFiles(files, trainingId) {
  async uploadTrainingFiles(files) {
    try {
      let formData = new FormData();

      for (const file of files) {

        if (file.type.startsWith('image/')) {
          const pdfBlob = await convertImageToPDF(file);
          const pdfFile = new File([pdfBlob], `${file.name}.pdf`, { type: 'application/pdf' });
          formData.append('files[]', pdfFile);
        } else {
          formData.append('files[]', file);
        }
      }

      const requestConfig = {
        headers: { 'Content-Type': 'multipart/form-data' },
      };

      // const response = await essApi.post(`uploadtrainingFile?trainingId=${trainingId}`, formData, requestConfig);
      const response = await essApi.post(`uploadtrainingFile`, formData, requestConfig);

      return Promise.resolve(response);
    } catch (error) {
      console.error('Error uploading files:', error);
      return Promise.reject(error);
    }
  }

  async getUserDetailsById(userId) {
    return Promise.resolve(essApi.get(`users/getDetailsbyuserid/${userId}`));
  }


  async uploadAttachment(formdata, type) {
    console.log(type, "TYPE")
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'filetype': type
      }
    };
    return Promise.resolve(essApi.post(`uploadAssesmentFeedbackFile`, formdata, config));
  }

}
export default TrainingService;
